export default __webpack_public_path__ + "static/media/globe-sm.5fb3e5cf.svg";